import { StyledComponentProps } from '@material-ui/core';
import { computed } from 'mobx';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { PleaseWait } from '../../comps/PleaseWait';
import { IReminder } from '../../main/entities';
import { mg } from '../../mg/mg';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { ReminderDialog, reminderDialogStore } from './ReminderDialog';

const dataviewStore = DataviewStore.create({
	id: 'ReminderList',
	orgColumns: [
		'templateReminderId',
		'templateId',
		'isOwn :bool',
		'isShared :bool',
		'status :UserTemplateReminder_Status',
		'nextAlarm :datetime',
		'id',
	],
	sorting: {column: 'nextAlarm'},
});

dataviewStore.addColumnHiderToNamed('DEFAULT', 'text');
dataviewStore.addColumnHiderToNamed('FIXED', 'branchName');
dataviewStore.addColumnHiderToNamed('HIDDEN', 'id', 'templateReminderId', 'templateId');

interface IReminderListProps {
}

export class ReminderList extends OcScreen<IReminderListProps & StyledComponentProps> {
	@computed get _isFiltered() {
		return getOmnistore().locationStore.page === 'LReminders';
	}

	usedStores = () => ['Template', 'Branch', 'Reminder']

	@computed get _etag() {
		const multirepo = getOmnistore().multirepo;
		const m = multirepo.reminderRepo.etag;
		if (!m) return '';
		const t = multirepo.templateRepo.etag;
		if (!t && this._isFiltered) return '';
		const b = multirepo.branchRepo.etag;
		return m + '/' + t + '/' + b;
	}

	@computed get _allAsList() : Array<IReminder> {
		const multirepo = getOmnistore().multirepo;
		const templates = multirepo.templateRepo.allAsList.filter(t => !this._isFiltered || t.branchId == getOmnistore().locationStore.branchId);
		const templateMap = mg.entriesToObject(templates.map(t => [t.id, t]));
		return multirepo.reminderRepo.allAsList
			.map(e => {
				const t = templateMap[e.templateId];
				if (!t) return;
				const b = multirepo.branchRepo.byId(t.branchId);
				return {...e, branchName: !b ? '?' : b.name};
			})
			.filter(mg.isPresent);
	}

	@computed get _repo() {
		return {
			etag: this._etag,
			allAsList: this._allAsList,
		};
	}

	autoruns() {
		return [
			() => {
				dataviewStore.setIgnoredColumnHiders([
					!this._isFiltered ? 'FIXED' : null,
				]);
			},
		];
	}

	render() {
		if (!this._repo.etag) return <PleaseWait/>;
		return <React.Fragment>
			<OcDataview repo={this._repo} state={dataviewStore}/>
			<ReminderDialog store={reminderDialogStore}/>
		</React.Fragment>;
	}
}
